export default __webpack_public_path__ + "static/ico-rozglos-2de980d1a7d3a2a5d406a45232f5a867.svg";